import React from "react";
import messages from "../../../locale/messages";
import AdminLayout from "../../../components/Layout/AdminLayout";
import ManageSubCategory from "./ManageSubCategory";
import NotFound from "../../../components/NotFound/NotFound";

function action({ store, intl, params }) {

    const title = intl.formatMessage(messages.editManageServices)
    const notFoundTitle = intl.formatMessage(messages.pageNotFound)
    const profileId = Number(params.id);
    const categoryId = Number(params.categoryid);

    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' };
    }

    if (!profileId || !categoryId) {
        return {
            title,
            component: (
                <NotFound title={notFoundTitle} />
            )
        }
    } 

    return {
        title,
        component: (
            <AdminLayout>
                <ManageSubCategory profileId={profileId} categoryId={categoryId} />
            </AdminLayout>
        )
    }
}

export default action;